export function subStr(time) {
    if (!time) return ''
    return time.substring(0,10)
}

// 时间截取

export function subTimeStr(str) {
    if (!str) return ''
    return str.substring(11)
}
export function toStrFixed(str) {
    if (!str) return ''
    return Math.round(str * 10000) / 10000
}
export function originAdd(id,list) {
    const data = {}
    if(list) {
        list.forEach(function(i,o){
            if(i.countryId===id){
                data['countryName'] = i.countryName
                data['countryEnName'] = i.countryEnName
                data['cityEnName'] = i.cityEnName
                data['cityName'] = i.cityName
            }
        })
        return data
    }
}

export function desAdd(id,list) {
    const data = {}
    if(list) {
        list.forEach(function(i,o){
            if(i.countryId===id){
                data['countryName'] = i.countryName
                data['countryEnName'] = i.countryEnName
                data['cityEnName'] = i.cityEnName
                data['cityName'] = i.cityName
            }
        })
        return data
    }
}

export function boxNum(list) {
    let  num = 0
    if(list) {
        list.forEach(function(i,o){
            num+=i.num

        })
        return num
    }
}
